import React from "react";
import { isEmpty } from "lodash";

import SectionContainer from "core/Components/SectionContainer";
import Wrapper from "elements/Components/BannerWithImage/components/Wrapper";
import ImageContainer from "elements/Components/BannerWithImage/components/ImageContainer";

type Props = {
    image: Image
};

const BannerWithImage: React.FC<Props> = ({ image }) => {
    return isEmpty(image?.id) ? null : (
        <SectionContainer>
            <Wrapper isImageFirst>
                <ImageContainer
                    image={image}
                    useFocusPoint={!!image.FocusPoint}
                    opacity={0}
                    gradientColor={"transparent"}
                />
            </Wrapper>
        </SectionContainer>
    );
}

export default BannerWithImage;
